/**
 * Aurika 3-dot window
 * Shows prev / active / next dot only.
 * Active dot = Aurika 4-petal gold motif (via CSS).
 * Watches aria-current mutations from the carousel-navigation custom element.
 *
 * NOTE: No broad document.body observer — that was causing Razorpay
 * Magic Checkout to fail by blocking their DOM event handlers.
 */
(function () {
  'use strict';

  function updateDots(nav) {
    var buttons = Array.from(nav.querySelectorAll('button'));
    if (!buttons.length) return;

    var activeIdx = buttons.findIndex(function (b) {
      return b.getAttribute('aria-current') === 'true';
    });
    if (activeIdx === -1) activeIdx = 0;

    var total = buttons.length;

    buttons.forEach(function (btn, i) {
      var state = null;
      if (i === activeIdx)           state = 'active';
      else if (i === activeIdx - 1)  state = 'prev';
      else if (i === activeIdx + 1)  state = 'next';
      // Edge: always show a ghost so 3 slots are always visible
      else if (activeIdx === 0 && i === 1)              state = 'next';  // already handled above
      else if (activeIdx === total - 1 && i === total - 2) state = 'prev'; // already handled above

      if (state) {
        btn.setAttribute('data-dot-state', state);
      } else {
        btn.removeAttribute('data-dot-state');
      }
    });

    // If at the start, inject a ghost placeholder before active so count = 3
    nav.toggleAttribute('data-at-start', activeIdx === 0);
    nav.toggleAttribute('data-at-end',   activeIdx === total - 1);
  }

  var observed = new WeakSet();

  function initNav(nav) {
    if (observed.has(nav)) return;
    observed.add(nav);

    updateDots(nav);

    // Only watch the nav element itself (not document.body)
    new MutationObserver(function () {
      updateDots(nav);
    }).observe(nav, {
      attributes: true,
      subtree: true,
      attributeFilter: ['aria-current']
    });
  }

  function scanAndInit() {
    document.querySelectorAll('.page-dots, .aurika-page-dots').forEach(initNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanAndInit);
  } else {
    scanAndInit();
  }

  // Watch only for new carousel navigation elements being added,
  // using a targeted observer on known carousel containers only
  document.addEventListener('DOMContentLoaded', function () {
    // Retry once after a short delay for any late-rendering sections
    setTimeout(scanAndInit, 800);
    setTimeout(scanAndInit, 2000);
  });
})();
